<template>
    <v-row >
        <v-col cols="12">
            <h2 class="mt-4">Facility Hours</h2>
        </v-col>
        <v-col cols="12" md="6">
            <h3 class="mb-3">Office Hours</h3>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Monday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-mon-switch"
                        class="facility-hours-mon-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.monday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.monday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-mon-open-input"
                        class="facility-hours-mon-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.monday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.monday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-mon-close-input"
                        class="facility-hours-mon-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.monday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Tuesday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-tues-switch"
                        class="facility-hours-tues-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.tuesday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.tuesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-tues-open-input"
                        class="facility-hours-tues-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.tuesday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.tuesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-tues-close-input"
                        class="facility-hours-tues-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.tuesday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Wednesday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-wed-switch"
                        class="facility-hours-wed-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.wednesday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.wednesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-wed-open-input"
                        class="facility-hours-wed-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.wednesday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.wednesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-wed-close-input"
                        class="facility-hours-wed-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.wednesday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Thursday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-thurs-switch"
                        class="facility-hours-thurs-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.thursday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.thursday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-thurs-open-input"
                        class="facility-hours-thurs-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.thursday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.thursday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-thurs-close-input"
                        class="facility-hours-thurs-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.thursday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Friday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-fri-switch"
                        class="facility-hours-fri-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.friday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.friday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-fri-open-input"
                        class="facility-hours-fri-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.friday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.friday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-fri-close-input"
                        class="facility-hours-fri-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.friday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Saturday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-sat-switch"
                        class="facility-hours-sat-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.saturday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.saturday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-sat-open-input"
                        class="facility-hours-sat-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.saturday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.saturday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-sat-close-input"
                        class="facility-hours-sat-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.saturday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Sunday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-sun-switch"
                        class="facility-hours-sun-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.office_hours.sunday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.sunday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-sun-open-input"
                        class="facility-hours-sun-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.sunday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.office_hours.sunday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-sun-close-input"
                        class="facility-hours-sun-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.office_hours.sunday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="6">
            <h3 class="mb-3">Access Hours</h3>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Monday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-mon-switch"
                        class="facility-hours-access-mon-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.monday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.monday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-mon-open-input"
                        class="facility-hours-access-mon-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.monday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.monday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-mon-close-input"
                        class="facility-hours-access-mon-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.monday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Tuesday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-tues-switch"
                        class="facility-hours-access-tues-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.tuesday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.tuesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-tues-open-input"
                        class="facility-hours-access-tues-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.tuesday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.tuesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-tues-close-input"
                        class="facility-hours-access-tues-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.tuesday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Wednesday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-wed-switch"
                        class="facility-hours-access-wed-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.wednesday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.wednesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-wed-open-input"
                        class="facility-hours-access-wed-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.wednesday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.wednesday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-wed-close-input"
                        class="facility-hours-access-wed-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.wednesday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Thursday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-thurs-switch"
                        class="facility-hours-access-thurs-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.thursday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.thursday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-thurs-open-input"
                        class="facility-hours-access-thurs-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.thursday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.thursday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-thurs-close-input"
                        class="facility-hours-access-thurs-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.thursday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Friday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-fri-switch"
                        class="facility-hours-access-fri-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.friday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.friday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-fri-open-input"
                        class="facility-hours-access-fri-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.friday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.friday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-fri-close-input"
                        class="facility-hours-access-fri-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.friday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Saturday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-sat-switch"
                        class="facility-hours-access-sat-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.saturday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.saturday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-sat-open-input"
                        class="facility-hours-access-sat-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.saturday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.saturday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-sat-close-input"
                        class="facility-hours-access-sat-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.saturday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6" md="2">
                    <p class="subheading pt-3">
                        Sunday
                    </p>
                </v-col>
                <v-col cols="6" md="2">
                    <v-switch
                        data-testid="facility-hours-access-sun-switch"
                        class="facility-hours-access-sun-switch"
                        tabindex="-1"
                        label="Open"
                        v-model="currentFacility.access_hours.sunday.enabled"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.sunday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-sun-open-input"
                        class="facility-hours-access-sun-open-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.sunday.open"
                        label="Open"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
                <v-col v-if="currentFacility.access_hours.sunday.enabled" cols="6" md="4">
                    <app-input
                        data-testid="facility-hours-access-sun-close-input"
                        class="facility-hours-access-sun-close-input"
                        :type="'text'"
                        v-model.trim="currentFacility.access_hours.sunday.close"
                        label="Close"
                        :rules="{ required: true }"
                        :useValidation="true"
                   />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import AppInput from "@/components/global/AppInput";

export default {
  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  },

  components: {
    AppInput
  }
};
</script>

<style scoped lang="scss">
h3 {
    text-align: center;
}
</style>
